import { Constants } from "../../../contants";
import {
  INITIATE_VIEW_MEMBER_DATA,
  SET_VIEW_MEMBER_DATA,
  SET_VIEW_MEMBER_DATA_FAIL,
  SET_SELECTED_MEMBER_TRANSFER,
  SET_VIEW_MEMBER_PAGE_DATA,
  SET_SELECTED_PENDING_TRANSFER_MEMBER,
  SET_SELECTED_PENDING_TRANSFER_MEMBER_REMARKS,
  SET_SELECTED_MEMBER_PROFILE,
  SET_SELECTED_FRIEND_FROM_SEARCH,
} from "../../actionTypes/dashboard";

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  error: null,
  paginationInfo: {
    currentPage: 0,
    totalPages: 1,
    totalElements: 0,
    pageSize: Constants.DEFAULT_PAGE_SIZE,
  },
  selectedMemberForTransfer: {},
  selectedMemberProfile: {},
  selectedMemberPendingTransfer: {
    remarks: {
      data: [],
      isLoading: false,
      error: null,
    },
  },
};

// eslint-disable-next-line default-param-last
const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case INITIATE_VIEW_MEMBER_DATA:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case SET_VIEW_MEMBER_DATA:
      return {
        ...state,
        data: action.payload?.content || [],
        isLoading: false,
        paginationInfo: payload?.paginationInfo,
      };
    case SET_VIEW_MEMBER_DATA_FAIL:
      return {
        ...state,
        data: [],
        isLoading: false,
        error: payload,
      };
    case SET_VIEW_MEMBER_PAGE_DATA:
      return {
        ...state,
        paginationInfo: payload?.paginationInfo,
      };
    case SET_SELECTED_MEMBER_TRANSFER:
      return {
        ...state,
        selectedMemberForTransfer: {
          ...state.selectedMemberForTransfer,
          ...payload,
        },
      };
    case SET_SELECTED_PENDING_TRANSFER_MEMBER:
      return {
        ...state,
        selectedMemberPendingTransfer: {
          ...state.selectedMemberPendingTransfer,
          ...payload,
          paginationInfo:
            payload?.paginationInfo ?? INITIAL_STATE.paginationInfo,
        },
      };
    case SET_SELECTED_MEMBER_PROFILE:
      return {
        ...state,
        selectedMemberProfile: payload,
      };
    case SET_SELECTED_PENDING_TRANSFER_MEMBER_REMARKS:
      return {
        ...state,
        selectedMemberPendingTransfer: {
          ...state.selectedMemberPendingTransfer,
          remarks: {
            ...state.selectedMemberPendingTransfer.remarks,
            data: payload,
          },
        },
      };

    case SET_SELECTED_FRIEND_FROM_SEARCH:
      return {
        ...state,
        selectedFriendFromSearch: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export default reducer;
